import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Table, { TableBody, TableCell, TableHead, TableRow } from 'material-ui/Table'

/**
 * receives transaction prop from transactionSwitcher
 * this component deals with displaying user transactions
 */
class UserTransaction extends Component {
    constructor(props) {
        //console.log("UserTransaction constructor " + props);
        super(props);
        this.state = {
            transactions: []
        };
    }

    componentDidMount() {
        //console.log("UserTransaction componentDidMount");
        //allows transactions to persist
        this.setState({
            transactions: this.props.transaction
        });

    }

    componentWillReceiveProps(nextProps) {
        //console.log("UserTransaction componentWillReceiveProps " + nextProps);
        //on nextProps, set the state to be rendered

        //console.log(nextProps);
        let trns = [];
        trns.push(nextProps);
        //console.log("trns",trns);
        //console.log("trns[0]",trns[0]);
        this.setState({
            transactions: trns[0]['transaction']
        });
    }


    render() {
      let typeClass = function(trnType){
        switch(trnType){
          case 'Sell':
            return 'sell-transaction transaction-log-row';
          case 'Buy':
            return 'buy-transaction transaction-log-row';
          case 'Bid':
            return 'bid-transaction transaction-log-row';
          case 'Ask':
            return 'ask-transaction transaction-log-row';
        }
      };
      let typeVerb = function(trnType){
        switch(trnType){
          case 'Sell':
            return 'Sold';
          case 'Buy':
            return 'Bought';
          case 'Bid':
            return 'Bid for';
          case 'Ask':
            return 'Offered';
        }
      }
      return (
        <Table className='transaction-log-table'>
          <TableHead className='transaction-log-header'>
            <TableRow className='transaction-log-row'>
              <TableCell className='transaction-log-cell'>Timestamp</TableCell>
              <TableCell className='transaction-log-cell'>Volume</TableCell>
              <TableCell className='transaction-log-cell'>Symbol</TableCell>
              <TableCell className='transaction-log-cell'>Type</TableCell>
              <TableCell className='transaction-log-cell'>Price</TableCell>
            </TableRow>
          </TableHead>

          <TableBody className='transaction-log-body'>
            {this.state.transactions.map((trn, index) => {
              return (
                <TableRow className={typeClass(trn.Type)}
                          key={index}>
                  <TableCell className='transaction-log-cell'>{trn.Time.substr(11,5)}</TableCell>
                  <TableCell className='transaction-log-cell'>{trn.Volume} shares of</TableCell>
                  <TableCell className='transaction-log-cell'>ABC were</TableCell>
                  <TableCell className='transaction-log-cell'>{typeVerb(trn.Type)} at</TableCell>
                  <TableCell className='transaction-log-cell'>${(trn.Price / 100).toFixed(2)}</TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      )
    }
}

UserTransaction.propTypes = {
    nextProps: PropTypes.array
};

export default UserTransaction;



// WEBPACK FOOTER //
// ./src/components/Orderbook/UserTransactions.js